import type { ApiError } from 'constants/errors';

export const isAbortedRequestError = (error?: ApiError | string) =>
  typeof error !== 'string' && !!error?.crossDomain && error?.status === undefined;
